import { Component, Input, ViewChildren, QueryList, AfterViewInit, inject } from '@angular/core';
import { AiAnswerResult } from '@pepconnect/models/ui/search/search.model';
import { Observable, takeUntil } from 'rxjs';
import { AiAnswerTextDirective } from './ai-answer-text.directive';
import { SearchCardComponent } from '@pepconnect/shared/presentation/cards/search-card/search-card.component';
import { BaseV2SmartComponent } from '@pepconnect/shared/base/base-smart-component-v2';
import { ScrollService } from '@pepconnect/shared/services/scroll.service';
import { AIResponseVoteRequestDto } from '@pepconnect/dtos/search/AIResponseVoteRequest.dto';
import { SearchService } from '@pepconnect/services/search.service';

@Component({
    selector: 'app-ai-answer',
    templateUrl: './ai-answer.component.html',
    styleUrl: './ai-answer.component.scss',
    standalone: false
})
export class AiAnswerComponent extends BaseV2SmartComponent implements AfterViewInit {
  @Input() answer: Observable<AiAnswerResult>;
  @Input() hasPotentialResultsToShow: boolean = true;
  @Input() loading: boolean = false;

  private readonly scrollService = inject(ScrollService);
  private readonly searchSvc = inject(SearchService);

  constructor() { super(); }

  clickedObjectId: string;
  expanded: boolean = false;

  private deHighlightTimeout: any;

  @ViewChildren(AiAnswerTextDirective)
  textDirectives: QueryList<AiAnswerTextDirective>;

  @ViewChildren(SearchCardComponent)
  searchCards: QueryList<SearchCardComponent>;

  ngAfterViewInit(): void {
    const subscribeDirective = (directive: AiAnswerTextDirective) => {
      directive.objectClicked.pipe(takeUntil(this.ngUnsubscribe)).subscribe((guid: string) => {
        this.selectObject(guid);
      });
    };
    this.textDirectives.changes.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.textDirectives.forEach(subscribeDirective);
    });

    this.textDirectives.forEach(subscribeDirective);
  }

  toggleExpand() {
    this.expanded = !this.expanded;
  }

  /**
   * Get the number of visual lines in the text and 
   * make sure it's large enough to justify a 'Show More' button.
   * @param text 
   * @returns 
   */
  shouldBeExpandable(text: string) {
    return text?.split(/<(?:h\d|p|br|li)/).length >= 5;
  }

  rateResponse(searchLogId: number, vote: number) {
    const payload: AIResponseVoteRequestDto = { searchLogId: searchLogId, vote: vote };
    this.searchSvc.rateAIAnswer(payload).subscribe();
  }

  selectObject(guid: string) {
    clearTimeout(this.deHighlightTimeout);

    this.clickedObjectId = guid;
    this.deHighlightTimeout = setTimeout(() => this.clickedObjectId = null, 1000);

    const card = this.searchCards?.find(c => c.result.objectID === guid);
    if (card) {
      this.scrollService.scrollTo(card.elementRef.nativeElement, { behavior: 'smooth', block: 'center' });
    }
  }
}
